import React, { useEffect, useState } from "react";
import { surveyResultPreview, getSingleSurvey, updateStatus, getAdminEmails } from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import { useNavigate } from "react-router-dom";
import { Snackbar, Grid, Button } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../api/config/apiConfig";
import gifLoading from "../../../imgs/giphy.gif";
import LazyImage from "../LazyLoadImage";
import PrintComponent from "../PrintComponent";
import SurveyPreviewDownload from "../SurveyPreviewPage/download";
import AssignSurveyorModal from "../../../components/molecules/AssignSurveyorModal";
import SuccessModal from "../../molecules/SuccessModal";
import RejectModal from "../../molecules/RejectModal";
import CreateFileModal from "../../molecules/CreateFileModal";

import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import AssignmentIcon from '@mui/icons-material/Assignment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PersonIcon from '@mui/icons-material/Person';
import ChatIcon from '@mui/icons-material/Chat';
import moment from "moment";

const SurveyDetailsPage = () => {
  const id = window.location.pathname.split("/")[2];
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();
  const [showAssign, setShowAssign] = useState(false);
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [reject, setReject] = useState(false);
  const [successHead, setSuccessHead] = useState("");
  const [successSub, setSuccessSub] = useState("");
  const [showCreateFile, setShowCreateFile] = useState(false);
  const [adminEmails, setAdminEmails] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("shelUserData"));
  const currentUserEmail = currentUser?.email;
  const [enrichedData, setEnrichedData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const printAction = () => {
    // Simply trigger the print dialog. 
    // The table-based layout in PrintComponent handles pagination automatically.
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const getSurvey = () => {
    setIsLoading(true);
    getSingleSurvey(id).then((response) => {
      setSurveyData(response?.data?.data);
      if (response?.data?.data?.status === "submitted") {
        getSurveyPreviewData();
      }
      setIsLoading(false);
    }).catch((error) => {
      setIsLoading(false);
      if (error?.response?.data?.statusCode == 401) {
        localStorage.clear(); window.location.pathname = "/login";
      }
    });
  };

  const getSurveyPreviewData = () => {
    surveyResultPreview(id)
      .then((response) => {
        setEnrichedData(response?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching survey preview:", error);
      });
  };

  const handleStatus = (val, id) => {
    const body = { status: val };
    if (val === "rejected") setReject(true);
    else {
      updateStatus(id, body).then(() => {
        setSnackbarMessage("Status updated successfully!");
        setOpenSnackbar(true);
        getSurvey();
      }).catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear(); window.location.pathname = "/login";
        } else {
          setSnackbarMessage(error?.response?.data?.message); setOpenSnackbar(true);
        }
      });
    }
  };

  useEffect(() => {
    getSurvey();
    getAdminEmails()
      .then((res) => setAdminEmails(res?.data?.data || []))
      .catch((error) => console.error(error));
  }, []);

  const isAdmin = adminEmails.includes(currentUserEmail);

  const formatDate = (unix) => {
    if(!unix) return "-";
    const date = new Date(unix * 1000);
    return date.toLocaleString('default', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  // Actions for the page header
  const pageActions = (
    <>
      <Button
        variant="contained"
        onClick={() => navigate(`/survey/incomplete/${surveyData?.uuid}/${surveyData?.status}`)}
        startIcon={<AssignmentIcon />}
        sx={{ 
          textTransform: "none", 
          borderRadius: "var(--radius-md)", 
          padding: "10px 24px",
          fontWeight: 700,
          backgroundColor: "var(--primary-color)",
          boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
          '&:hover': { backgroundColor: 'var(--primary-hover)' }
        }}
      >
        Update Details
      </Button>

      {surveyData?.status === "submitted" && (
        <Button
          variant="contained"
          onClick={() => {
            if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
            const newTitle = `Survey Preview-${enrichedData?.surveyDetail?.name || 'Details'}-${moment().format("DD.MM.YYYY")}`;
            document.title = newTitle;
            
            // Call printAction which handles the print and cleanup
            printAction();
            
            // Restore title after a longer delay to ensure print dialog caught it
            setTimeout(() => {
              document.title = tempTitle;
            }, 2000);
          }}
          disabled={!enrichedData}
          startIcon={<DescriptionIcon />}
          sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--text-main)",
            boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
            '&:hover': { backgroundColor: '#000' }
          }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout 
        title="Shipment Details" 
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <div className="mx-auto survey-details-wrapper">
          <Grid container spacing={4}>
            {/* Sidebar Stats */}
            <Grid item xs={12} md={4}>
              <PremiumCard>
                <div className="d-flex align-items-center gap-3 mb-4">
                  <div className={`status-pill ${surveyData?.status}`}>
                    {surveyData?.status}
                  </div>
                  <span className="premium-label" style={{ marginBottom: 0 }}>Current Status</span>
                </div>
                
                <div className="mb-4">
                  <label className="premium-label mb-1">Assigned To</label>
                  <p className="fw-bold mb-0" style={{ color: 'var(--text-main)' }}>{surveyData?.surveyer?.name || "Unassigned"}</p>
                </div>

                <div className="mb-4 pt-3 border-top">
                  <label className="premium-label mb-1">Contact Email</label>
                  <p className="small mb-0 text-break" style={{ color: 'var(--text-muted)' }}>{surveyData?.email}</p>
                </div>

                <div className="mt-4 pt-4 border-top">
                  <h5 className="fw-bold mb-3">Quick Actions</h5>

                  {surveyData?.surveyer && (
                    <Button 
                      fullWidth
                      variant="contained"
                      onClick={() => navigate('/communication', {
                        state: {
                          surveyId: surveyData.uuid,
                          surveyerId: surveyData.surveyer?.uuid,
                          surveyerName: surveyData.surveyer?.name,
                        }
                      })}
                      startIcon={<ChatIcon />}
                      sx={{ 
                        mb: 2, 
                        textTransform: 'none', 
                        fontWeight: 700,
                        backgroundColor: '#4f46e5',
                        boxShadow: '0 4px 14px rgba(79, 70, 229, 0.3)',
                        '&:hover': { backgroundColor: '#4338ca' }
                      }}
                    >
                      Chat with Surveyor
                    </Button>
                  )}
                  
                  {surveyData?.status === "submitted" && (
                    <Button 
                      fullWidth
                      variant="outlined"
                      onClick={() => navigate(`/survey-preview/${surveyData?.uuid}`)}
                      sx={{ mb: 2, textTransform: 'none', fontWeight: 700 }}
                    >
                      View Preview
                    </Button>
                  )}

                  {(surveyData?.status == "new" || surveyData?.status == "rejected") && (
                    <Button 
                      fullWidth
                      variant="contained"
                      onClick={() => setShowAssign(true)}
                      sx={{ mb: 2, textTransform: 'none', fontWeight: 700 }}
                    >
                      Assign Surveyor
                    </Button>
                  )}

                  {surveyData?.status == "assigned" && (
                    <Button 
                      fullWidth
                      variant="outlined"
                      color="warning"
                      onClick={() => handleStatus("un_assign", surveyData?.uuid)}
                      sx={{ mb: 2, textTransform: 'none', fontWeight: 700 }}
                    >
                      Unassign
                    </Button>
                  )}

                  {(surveyData?.status == "new" || surveyData?.status == "assigned") && (
                    <Button 
                      fullWidth
                      variant="contained"
                      color="error"
                      onClick={() => handleStatus("rejected", surveyData?.uuid)}
                      sx={{ mb: 2, textTransform: 'none', fontWeight: 700 }}
                    >
                      Reject Shipment
                    </Button>
                  )}
                  
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                      if (!isAdmin) {
                        setSnackbarMessage("Only super admin can see and update this file");
                        setOpenSnackbar(true);
                      } else {
                        setShowCreateFile(true);
                      }
                    }}
                    sx={{ textTransform: 'none', fontWeight: 700 }}
                  >
                    Generate Quote
                  </Button>
                </div>
              </PremiumCard>
            </Grid>

            {/* Main Content */}
            <Grid item xs={12} md={8}>
              {/* Personal Information */}
              <SectionHeader title="Personal Information" icon={<PersonIcon />} />
              <PremiumCard sx={{ mb: 4 }}>
                <div className="details-grid-premium">
                  <div className="detail-item-premium">
                    <span>Full Name</span>
                    <p>{surveyData?.name || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>Email</span>
                    <p>{surveyData?.email || "-"}</p>
                  </div>
                  <div className="detail-item-premium full-width">
                    <span>Description</span>
                    <p>{surveyData?.description || "-"}</p>
                  </div>
                </div>
              </PremiumCard>

              {/* Origin & Logistics */}
              <SectionHeader title="Origin & Logistics" icon={<LocationOnIcon />} />
              <PremiumCard sx={{ mb: 4 }}>
                <div className="details-grid-premium">
                  <div className="detail-item-premium full-width">
                    <span>Street Address</span>
                    <p>{surveyData?.loadPlaceStAddress || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>City</span>
                    <p>{surveyData?.loadPlaceCity || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>Zip Code</span>
                    <p>{surveyData?.loadPlaceZip || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>Removal Date</span>
                    <p>{formatDate(surveyData?.loadDate)}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>Shipment Date</span>
                    <p>{formatDate(surveyData?.surveyDate)}</p>
                  </div>
                </div>
              </PremiumCard>

              {/* Destination */}
              <SectionHeader title="Destination" icon={<LocationOnIcon />} />
              <PremiumCard sx={{ mb: 4 }}>
                <div className="details-grid-premium">
                  <div className="detail-item-premium full-width">
                    <span>Street Address</span>
                    <p>{surveyData?.unloadPlaceStAddress || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>City</span>
                    <p>{surveyData?.unloadPlaceCity || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>Zip Code</span>
                    <p>{surveyData?.unloadPlaceZip || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>Country</span>
                    <p>{surveyData?.unloadPlaceCountry || "-"}</p>
                  </div>
                  <div className="detail-item-premium">
                    <span>Telephone</span>
                    <p>{surveyData?.unloadPlacePhone || "-"}</p>
                  </div>
                </div>
              </PremiumCard>

              {/* Rooms Detail Section */}
              {surveyData?.status === "submitted" && surveyData?.surveyResult?.surveyRooms?.length > 0 && (
                <div className="mt-5">
                   <SectionHeader title="Rooms Inventory" icon={<MeetingRoomIcon />} />
                   {surveyData.surveyResult.surveyRooms.map((sr, ind) => {
                      return (
                        <PremiumCard key={ind} sx={{ mb: 4 }}>
                           <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
                              <h4 className="fw-bold mb-0" style={{ color: 'var(--primary-color)' }}>{ind + 1}. {sr.name}</h4>
                              <div className="small text-muted fw-bold">Items count: {sr?.roomItems?.length || 0}</div>
                           </div>

                           <Grid container spacing={4}>
                              {/* Room Images */}
                              <Grid item xs={12} lg={5}>
                                 <div className="d-flex flex-wrap gap-2">
                                    {sr?.images?.map((img, i) => (
                                       <div key={i} style={{ borderRadius: '12px', overflow: 'hidden', border: '2px solid rgba(0,0,0,0.05)' }}>
                                          <LazyImage src={Bucket + img} placeholderSrc={gifLoading} height={180} width={130} style={{ objectFit: 'cover' }} />
                                       </div>
                                    ))}
                                 </div>
                                 {sr?.remarks && (
                                    <div className="mt-4 p-3" style={{ background: 'rgba(79, 70, 229, 0.05)', borderRadius: '12px', borderLeft: '4px solid var(--primary-color)' }}>
                                       <span className="premium-label" style={{ marginBottom: '4px' }}>Remarks</span>
                                       <p className="small mb-0 fw-medium">{sr.remarks}</p>
                                    </div>
                                 )}
                              </Grid>

                              {/* Item Tables */}
                              <Grid item xs={12} lg={7}>
                                 {['movable', 'nonmovable', 'packing'].map((itemType) => {
                                    const items = itemType === 'packing' 
                                       ? sr.packingMaterial 
                                       : sr.roomItems?.filter(v => v.type === itemType);
                                    
                                    if (!items || items.length === 0) return null;

                                    const label = itemType === 'movable' ? 'Moving Items' 
                                                : itemType === 'nonmovable' ? 'Not Moving' 
                                                : 'Packing Material';
                                    const labelColor = itemType === 'nonmovable' ? 'var(--error)' : 'inherit';

                                    return (
                                       <div className="mb-4" key={itemType}>
                                          <span className="premium-label" style={{ color: labelColor }}>{label}</span>
                                          <div className="premium-table-container">
                                             <table className="premium-table">
                                                {itemType === 'movable' && (
                                                   <thead>
                                                      <tr>
                                                         <th>Item Name</th>
                                                         <th className="text-center">Qty</th>
                                                         <th className="text-end">CBM</th>
                                                      </tr>
                                                   </thead>
                                                )}
                                                <tbody>
                                                   {items.map((item, pi) => (
                                                      <tr key={pi}>
                                                         <td style={{ color: itemType === 'nonmovable' ? 'var(--text-muted)' : 'inherit' }}>{item.name}</td>
                                                         <td className={`text-center ${itemType === 'nonmovable' ? 'fw-medium text-muted' : 'fw-bold'}`}>{item.quantity}x</td>
                                                         <td className={`text-end ${itemType === 'nonmovable' ? 'text-muted' : ''}`}>{item.cbm?.toFixed(3)} m³</td>
                                                      </tr>
                                                   ))}
                                                </tbody>
                                             </table>
                                          </div>
                                       </div>
                                    );
                                 })}
                              </Grid>
                           </Grid>
                        </PremiumCard>
                      );
                   })}
                </div>
              )}
            </Grid>
          </Grid>
        </div>

        {/* Modals */}
        <AssignSurveyorModal 
          open={showAssign} 
          onClose={() => setShowAssign(false)}
          onSucces={(val) => {
            setEmail(val); setSuccessHead("Shipment Assigned Successfully");
            setSuccessSub("You have successfully assigned shipment to ");
            setShowAssign(false); setSuccess(true); getSurvey();
          }}
          id={id}
        />

        <SuccessModal open={success} onClose={() => setSuccess(false)} email={email} head={successHead} sub={successSub} />

        <RejectModal 
          open={reject} 
          onClose={() => setReject(false)}
          onSucces={() => {
            setEmail(""); setReject(false); setSuccess(true);
            setSuccessHead("Shipment Rejected Successfully");
            setSuccessSub("You have successfully rejected the shipment");
            getSurvey();
          }}
          id={id}
        />

        <CreateFileModal open={showCreateFile} onClose={() => setShowCreateFile(false)} id={id} />

        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successful") ? "success" : "error"} onClose={handleCloseSnackbar}>
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>

      </PremiumPageLayout>

      <PrintComponent>
        {enrichedData && <SurveyPreviewDownload surveyData={enrichedData} />}
      </PrintComponent>
    </>
  );
};

export default SurveyDetailsPage;
